import React from "react";
import { Edit2 } from 'react-feather';

import './index.scss'

const EditButton = ({
  onClick,
  title
}) => {


  return (
    <>
      {
        <div className="Edit2-button__Edit2" onClick={onClick}><Edit2 />{title}</div>
      }
    </>
  )
}

export default EditButton
